import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {MdCheckbox} from 'core/components/fields/fields';
import remove = require("lodash/remove");
import {moveItem} from 'core/common/utils/arrayUtils';
import GridConfigColumn from 'core/grid/domain/gridConfigColumn';
import {fieldStyles} from 'core/form/createForm';
import ChevronLeft from "material-ui/svg-icons/navigation/chevron-left";
import ChevronRight from "material-ui/svg-icons/navigation/chevron-right";
import ExpandLess from "material-ui/svg-icons/navigation/expand-less";
import ExpandMore from "material-ui/svg-icons/navigation/expand-more";
import MdEntity from "core/metamodel/mdEntity";
import GridConfig from "core/grid/domain/gridConfig";
import {action} from "mobx";
import FaSearch = require("react-icons/lib/fa/search");
import {FieldGroup} from 'core/form/formUtils';
import {FormControl} from "react-bootstrap";

import {grey400} from "material-ui/styles/colors";

import 'core/grid/component/columnSelector.less';
import {observer} from "mobx-react";
import {DATATYPE} from "core/metamodel/mdField";
import {classNames} from "core/common/utils/domUtils";
import {loc} from "core/common/config/locales";



interface ColumnSelectorProps {
  entity: MdEntity;
  gridConfig: GridConfig;
  disabled: boolean;
}
interface ColumnSelectorState {
  lastClickedIndex?: number;
  availableColumnsSearchTerm?: string;
}

const __buttonStyle = {width: 40, minWidth: 40, marginTop: 5, marginBottom: 5};


@observer
export default class ColumnSelector extends React.Component<ColumnSelectorProps, ColumnSelectorState> {

  state = {
    lastClickedIndex: null,
    availableColumnsSearchTerm: ""
  };


  /* ****************   EVENT HENDLERS ************************************************************ */


  @action onClickPridat = () => {
    let {gridConfig, entity} = this.props;

    let selectedFields = entity.getFields().filter(field => field.$selected);

    console.log('onClickPridat selectedFields: %O', selectedFields);

    selectedFields.forEach(field => {
      field.$selected = undefined;
      gridConfig.columns.push( new GridConfigColumn(gridConfig, {field} ) );
    });
  };

  @action onClickOdstranit = () => {
    let {gridConfig, entity} = this.props;

    let selectedFields = gridConfig.columns.filter(field => field.$selected);

    console.log('onClickOdstranit selectedFields: %O', selectedFields);

    selectedFields.forEach(gcc => {
      gcc.$selected = undefined;
      remove(gridConfig.columns, c => c.field.fieldKey === gcc.field.fieldKey);
    });

  };



  @action onClickUp = () => {
    let {gridConfig, entity} = this.props;

    let copy = gridConfig.columns.slice(0);
    for(let i = 0; i < copy.length; i++) {
      if (copy[i].$selected) {
        if (i < 1) return;
        moveItem(gridConfig.columns, i, i - 1);
      }
    }
  };

  @action onClickDown = () => {
    let {gridConfig, entity} = this.props;

    let copy = gridConfig.columns.slice(0);
    for (let i = copy.length - 1; i >= 0; i--) {
      if (copy[i].$selected) {
        if (i >= copy.length - 1) return;
        moveItem(gridConfig.columns, i, i + 1);
      }
    }
  };



  @action handleSelectedItemClick = (obj, index, objArray, evt)  => {
    console.log('handleSelectedItemClick ', evt.ctrlKey);

    let lastIndex = this.state.lastClickedIndex;

    if (evt.ctrlKey) {
      obj.$selected = !obj.$selected;
    } else if (evt.shiftKey && lastIndex != null) {
      for(let i = 0; i < objArray.length; i++) {
        objArray[i].$selected = (i >= Math.min(lastIndex, index) && i <= Math.max(lastIndex, index) );
      }
    } else {
      objArray.forEach(o => o.$selected = undefined);
      obj.$selected = true;
    }

    this.setState({lastClickedIndex: index});
  };

  @action handleSelectedItemMouseEnter = (obj, index, objArray, evt)  => {
    if (evt.button === 1 || evt.buttons === 1) {
      obj.$selected = true;
      this.forceUpdate();
    }
  };

  @action onSearchAvailableColumns = (evt) => {
    console.log("onSearchAvailableColumns: evt = %s", evt.target.value);
    this.setState({availableColumnsSearchTerm: evt.target.value});
  };


  onCheckSum = (obj, evt, checked)  => {
    console.log('onCheckSum obj = ', obj, checked);
    obj.sum = checked;
  };

  onCheckAvg = (obj, evt, checked)  => {
    console.log('onCheckAvg obj = ', obj, checked);
    obj.avg = checked;
  };

  render() {
    let {gridConfig, entity, disabled} = this.props;
    let {availableColumnsSearchTerm} = this.state;

    let selectedObjects = gridConfig.columns;
    let selectedObjectsNames = selectedObjects.map(v => v.field.fieldName);

    let allObjects = entity.getFields().filter(field => field.visible && !selectedObjectsNames.includes(field.fieldName)
      && (!availableColumnsSearchTerm || field.label.toLowerCase().includes(availableColumnsSearchTerm.toLowerCase())) );


    return (
      <div className="columnSelector">

        <div className="selectbox-wrapper">
          <div className="selectbox-search-wrapper">
            <span>{loc.i18n`Available Columns`}</span>
            <div className="selectbox-search">
              <FormControl type="text" onChange={this.onSearchAvailableColumns} value={availableColumnsSearchTerm} />
              <FaSearch style={{position: 'absolute', top: 2, right: 2, color: grey400}}/>
            </div>
          </div>

          <ul className="selectbox">
            {
              allObjects.map( (obj, index) => {
                return (
                  <li key={index} value={obj.fieldName} className={classNames('selectbox-item', {'selectbox-item--selected': obj.$selected})}
                      onClick={this.handleSelectedItemClick.bind(this, obj, index, allObjects)}
                      onMouseEnter={this.handleSelectedItemMouseEnter.bind(this, obj, index, allObjects)}
                      onMouseLeave={this.handleSelectedItemMouseEnter.bind(this, obj, index, allObjects)}>
                    <span>{obj.label}</span>
                  </li>
                );
              })
            }
          </ul>
        </div>

        <div className="addbuttons">
          <RaisedButton style={__buttonStyle} primary onClick={this.onClickPridat} icon={<ChevronRight/>} disabled={disabled}/>
          <RaisedButton style={__buttonStyle} primary onClick={this.onClickOdstranit} icon={<ChevronLeft/>} disabled={disabled}/>
        </div>

        <div className="selectbox-wrapper">
          <div className="selectbox-header">
            <div style={{flexGrow: 1}}>{loc.i18n`Grid Columns`}</div>
            <div style={{width: 40}}>{loc.i18n`Sum`}</div>
            <div style={{width: 62}}>{loc.i18n`Avg`}</div>
          </div>
          <ul className="selectbox">
            {
              selectedObjects.map( (obj: GridConfigColumn, index) => {
                return (
                  <li key={index} value={obj.field.fieldName} className={classNames('selectbox-item', {'selectbox-item--selected': obj.$selected})}
                      onClick={this.handleSelectedItemClick.bind(this, obj, index, selectedObjects)}
                      onMouseEnter={this.handleSelectedItemMouseEnter.bind(this, obj, index, allObjects)}
                      onMouseLeave={this.handleSelectedItemMouseEnter.bind(this, obj, index, allObjects)}>
                    <span style={{flexGrow: 1}}>{obj.label}</span>
                    {  (obj.field.fieldKey && (obj.field.dataType === DATATYPE.NUMBER || obj.field.dataType === DATATYPE.NUMBERCURRENCY || obj.field.dataType === DATATYPE.DURATION || obj.field.dataType === DATATYPE.BOOLEAN)) ?
                      <MdCheckbox style={Object.assign(fieldStyles.small.default.style, {width: 'inherit', height: 25})} name="sum"
                                checked={obj.sum}
                                onCheck={this.onCheckSum.bind(this, obj)}/>
                      : null
                    }
                    {  (obj.field.fieldKey && (obj.field.dataType === DATATYPE.NUMBER || obj.field.dataType === DATATYPE.NUMBERCURRENCY || obj.field.dataType === DATATYPE.DURATION || obj.field.dataType === DATATYPE.BOOLEAN)) ?
                      <MdCheckbox style={Object.assign(fieldStyles.small.default.style, {width: 'inherit', height: 25})} name="Avg"
                                  checked={obj.avg}
                                  onCheck={this.onCheckAvg.bind(this, obj)}/>
                      : null
                    }
                  </li>
                );
              })
            }
          </ul>
        </div>


        <div className="sortbuttons">
          <RaisedButton style={__buttonStyle} primary onClick={this.onClickUp} icon={<ExpandLess/>} disabled={disabled}/>
          <RaisedButton style={__buttonStyle} primary onClick={this.onClickDown} icon={<ExpandMore/>} disabled={disabled}/>
        </div>


      </div>
    )
  }


}




// WEBPACK FOOTER //
// ./src/core/grid/component/columnSelector.tsx